import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { PersonService } from '../service/person.service';
import { AdminshareService } from '../service/adminshare.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AViewTextModalComponent } from '../a0106-mail/a-view-text-modal.component';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';

@Component({
    selector: 'progress-app',
    templateUrl: './progress.component.html',
    styleUrls: ['progress.component.css']
})
export class ProgressComponent implements OnInit {
    @Input() event_id: number;
    title: string = '受検状況';

    page : number = 1;
    all_count:number=0;
    display_per_page:  number = 20;   /* 最大表示件数 */

    question_category_list: any = [];
    selected_question_category_id: number = null;
    datalist: any = [];
    all_datalist: any = [];
    selectedList: any = [];

    event: any = [];
    selected_event_id: number = null;
    search_open: any = false;
    isLoaded: boolean = false;

    //Form
    search: any = [];
    inputCompany: any;
    inputSyozoku: any;
    minPercentValue: number = 0;
    percentValue: number = 100;
    errorMessage: string = "";
    ROLE: any = Role;

    constructor(
        private commonService: CommonService,
        private adminShareService: AdminshareService,
        private personService: PersonService,
        public usersService: UsersService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) { }

    ngOnInit(): void {
        this.selected_event_id = +this.route.snapshot.paramMap.get('eid');
        this.getList();
    };

    clearData(): void {
        this.isLoaded = false;
        this.datalist = [];
        // this.question_category_list = [];
    }

    getList(): void {
        this.clearData();
        let param ={
            eid:this.selected_event_id,
            page:this.page,
            display_per_page:this.display_per_page
        };
        this.personService.getProgress(param)
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    this.event = res["fuel_results"]['event'];
                    if (this.event.length==0){
                        //対象のイベントがないメッセージを表示し、イベント一覧画面へ飛ばす
                        this.commonService.modalOpens(11007,modalresult=>{
                            this.router.navigate(["/event"]);
                            });
                        }
        
                    //searchは初回の値を使い続ける
                    if (this.search.length == 0) this.search = res["fuel_results"]['search'];

                    //紐づけられた問診が存在しないとデータを出力しない
                    if (this.search['question_category'].length > 0) {

                        this.all_count = res["fuel_results"]["all_count"];
                        this.all_datalist = res["fuel_results"]["progress"];
                        this.changePage(1);
                    }
                    this.isLoaded = true;
                }else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                }else{
                    this.commonService.modalOpens(11003,modalresult=>{});
                }
            }, error => {
                this.commonService.modalOpens(error, modalresult => { });
            });
    }

    searchProgress(mode:number) {
        if(mode == 1){
            this.page = 1;   
        }
        let checkedCategoryList = [];
        let cateList = this.search.question_category;
        for (let i in cateList) {
            let tempCate = cateList[i];
            if (tempCate["cate_check"]) {
                checkedCategoryList.push(parseInt(tempCate["t_question_category_id"]));
            }
        }

        //検索窓を開いた状態で、checkedCategoryListが空の場合は必ずデータ件数は0件
        if (checkedCategoryList.length == 0 && this.search_open) {
            if (cateList.length == 0) {
                checkedCategoryList = null;
            } else {
                this.datalist = [];
                return;
            }
        }

        let params = {
            "event_id": this.selected_event_id,
            "tc_id": this.inputCompany != "null" ? this.inputCompany : null,
            "ts_name": this.inputSyozoku,
            "cate_list": checkedCategoryList,
            "percent_value": this.percentValue,
            "min_percent_value": this.minPercentValue,
            "page":this.page,
            "display_per_page":this.display_per_page
        };

        this.clearData();
        this.personService.getProgressSearch(params)
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    this.all_count = res["fuel_results"]["all_count"];
                    this.all_datalist = res["fuel_results"]["progress"];
                    this.changePage(1);

                    this.isLoaded = true;
                }else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                }else{
                    this.commonService.modalOpens(11003,modalresult=>{});
                }
            }, error => {
                this.commonService.modalOpens(error, modalresult => { });
            });
    }
    selectP(row){
        if (row.selected){
            if (this.checkSelectedList(row['t_syozoku_id'])){
            }else{
                this.selectedList.push(row)
            }
        }
        else{
            this.selectedList = this.selectedList.filter(
                item =>
                    item.t_syozoku_id != row.t_syozoku_id
            );
        }
    }
    changePage(e){
        var start = (e-1)*this.display_per_page;
        this.datalist = this.all_datalist.slice(start, start+this.display_per_page);
        for (let i = 0; i < this.datalist.length; i++) {
            if (this.checkSelectedList(this.datalist[i]['t_syozoku_id'])){
                this.datalist[i]['selected'] = true;
            } else{
                this.datalist[i]['selected'] = false;
            }
        }
    }

    //selectedListにt_syozoku_idが含まれているか
    checkSelectedList(id:string):boolean{
        var row = this.selectedList.filter(
            item =>
                item.t_syozoku_id === id
        );
        if (row.length>0){
            return true
        }else{
            return false
        }
    }

    selectedlistOpen() : void {
        const modalRef = this.modalService.open(
            AViewTextModalComponent,//対象のComponent
            { backdrop: 'static', keyboard: false,size: 'lg' }//オプション設定　Esc,背景クリックの時の処理…停止中
        );

        let sendlisttext :string = "";

        modalRef.componentInstance.view_title = '選択リスト';
        sendlisttext = "全"+this.selectedList.length + "件<br>";
        for (let i = 0; i < this.selectedList.length; i++) {
            sendlisttext += this.selectedList[i]['t_company_nm_short']+"："+this.selectedList[i]['t_syozoku_name'] + "<br>";
        }

        modalRef.componentInstance.view_text = sendlisttext;
        modalRef.result.then(
            result => {
                if(result.status=='Cancel'){
                    //Cancel時の処理
                }else{
                    
                }
            }, function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
            }
        );
    }
    //a0106メール配信
    goMail(row: any): void {
        this.adminShareService.from_page = "syozoku";
        this.adminShareService.temp_send_list = [];
        this.adminShareService.temp_send_list.push(
            {
                t_company_id: row.t_company_id,
                company_name: row.t_company_name,
                company_nm_short: row.t_company_nm_short,
                t_syozoku_id: row.t_syozoku_id,
                syozoku_nm_short: row.t_syozoku_nm_short,
                syozoku_name: row.t_syozoku_name,
            }
        );
        this.router.navigate(["/mail/" + this.selected_event_id]);
    }
    //a0106メール配信(選択した所属全部)
    goMailAll(): void {
        this.adminShareService.from_page = "syozoku";
        this.adminShareService.temp_send_list = [];
        for (let i in this.selectedList) {
            var row =   this.selectedList[i];                  
            this.adminShareService.temp_send_list.push(
                {
                    t_company_id: row.t_company_id,
                    company_name: row.t_company_name,
                    company_nm_short: row.t_company_nm_short,
                    t_syozoku_id: row.t_syozoku_id,
                    syozoku_nm_short: row.t_syozoku_nm_short,
                    syozoku_name: row.t_syozoku_name,
                }
            );
        }
        this.router.navigate(["/mail/" + this.selected_event_id]);
    };
    //a0108個人データ
    goPerson(row: any): void {
        let categoryList = [];
        for (let i = 0; i < row.question_category.length; i++) {
            categoryList.push(parseInt(row.question_category[i]["tqc_id"]));
        }

        this.adminShareService.search_item = {
            "t_company_id": row.t_company_id,
            "t_syozoku_code": row.t_syozoku_code,
            "category_list": categoryList,
        }
        this.router.navigate(["/person/" + this.selected_event_id]);
    }
    goBack(): void {
        this.location.back();
    }

    checkFromTo(fromValue: Number, toValue: Number) {
        if (fromValue === null) {
            this.errorMessage = "Fromの値が不正な値です";
            return true;
        } else if (toValue === null) {
            this.errorMessage = "Toの値が不正な値です";
            return true;
        } else if (fromValue < 0) {
            this.errorMessage = "Fromの値が0未満になっています";
            return true;
        } else if (toValue < 0) {
            this.errorMessage = "Toの値が0未満になっています";
            return true;
        } else if (fromValue > 100) {
            this.errorMessage = "Fromの値が100を超えています";
            return true;
        } else if (toValue > 100) {
            this.errorMessage = "tToの値が100を超えています";
            return true;
        }else if(fromValue > toValue){
            this.errorMessage = "受検率の大小関係が不正です";
            return true;
        }

        this.errorMessage = "";
        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/a0107-progress/progress.component.ts